import { konstants } from '@vizeat/helpers'

export const CATEGORY_VISIBILITY_ICONS = {
  [konstants.CATEGORY_VISIBILITIES.PRIVATE]: 'lock',
  [konstants.CATEGORY_VISIBILITIES.PUBLIC]: 'eye',
  [konstants.CATEGORY_VISIBILITIES.PARTNER]: 'shopping bag',
}
